export const LAYER_ACTION_TYPE = {
  SHOW_STYLE: 'show-style',
  SHOW_STYLE_LABEL: 'show-style-label',
  SHOW_FILTER_DATA: 'show-filter-data',
  SHOW_TABLE: 'show-table',
  SHOW_DETAIL: 'show-detail',
  SHOW_LABEL: 'show-label',
  DOWNLOAD: 'show-download',
}
